export const INIT_LITE_TRADE_ACTION = 'INIT_LITE_TRADE_ACTION' as const;
export const INIT_LITE_TRADE_SUCCESS = 'INIT_LITE_TRADE_SUCCESS' as const;
export const INIT_LITE_TRADE_FAILURE = 'INIT_LITE_TRADE_FAILURE' as const;

export const PING_LITE_TRADE_ACTION = 'PING_LITE_TRADE_ACTION' as const;
export const PING_LITE_TRADE_SUCCESS = 'PING_LITE_TRADE_SUCCESS' as const;
export const PING_LITE_TRADE_FAILURE = 'PING_LITE_TRADE_FAILURE' as const;

export const SET_LITE_TRADE_SOCKET_STATE = 'SET_LITE_TRADE_SOCKET_STATE' as const;

export const LOGIN_LITE_TRADE_ACTION = 'LOGIN_LITE_TRADE_ACTION' as const;
export const LOGIN_LITE_TRADE_SUCCESS = 'LOGIN_LITE_TRADE_SUCCESS' as const;
export const LOGIN_LITE_TRADE_FAILURE = 'LOGIN_LITE_TRADE_FAILURE' as const;

export const LOGOUT_LITE_TRADE_ACTION = 'LOGOUT_LITE_TRADE_ACTION' as const;
export const LOGOUT_LITE_TRADE_SUCCESS = 'LOGOUT_LITE_TRADE_SUCCESS' as const;
export const LOGOUT_LITE_TRADE_FAILURE = 'LOGOUT_LITE_TRADE_FAILURE' as const;

export const SET_LITE_TRADE_ACCOUNT_METRICS = 'SET_LITE_TRADE_ACCOUNT_METRICS' as const;
export const SET_LITE_TRADE_ACCOUNT_PORTFOLIO = 'SET_LITE_TRADE_ACCOUNT_PORTFOLIO' as const;

export const GET_LITE_TRADE_ASSETS_ACTION = 'GET_LITE_TRADE_ASSETS_ACTION' as const;
export const GET_LITE_TRADE_ASSETS_SUCCESS = 'GET_LITE_TRADE_ASSETS_SUCCESS' as const;
export const GET_LITE_TRADE_ASSETS_FAILURE = 'GET_LITE_TRADE_ASSETS_FAILURE' as const;

export const PROCESS_LITE_TRADE_POSITION_NOTIFICATION = 'PROCESS_LITE_TRADE_POSITION_NOTIFICATION' as const;
export const PROCESS_LITE_TRADE_REJECTED_ORDER_NOTIFICATION = 'PROCESS_LITE_TRADE_REJECTED_ORDER_NOTIFICATION' as const;
export const PROCESS_LITE_TRADE_ORDER_NOTIFICATION = 'PROCESS_LITE_TRADE_ORDER_NOTIFICATION' as const;

/**
 * @deprecated use OPEN_LITE_TRADE_POSITION_ACTION/CLOSE_LITE_TRADE_POSITION_ACTION
 */
export const CREATE_LITE_TRADE_ORDER_ACTION = 'CREATE_LITE_TRADE_ORDER_ACTION' as const;
export const CREATE_LITE_TRADE_ORDER_SUCCESS = 'CREATE_LITE_TRADE_ORDER_SUCCESS' as const;
export const CREATE_LITE_TRADE_ORDER_FAILURE = 'CREATE_LITE_TRADE_ORDER_FAILURE' as const;

export const OPEN_LITE_TRADE_POSITION_ACTION = 'OPEN_LITE_TRADE_POSITION_ACTION' as const;
export const OPEN_LITE_TRADE_POSITION_SUCCESS = 'OPEN_LITE_TRADE_POSITION_SUCCESS' as const;
export const OPEN_LITE_TRADE_POSITION_FAILURE = 'OPEN_LITE_TRADE_POSITION_FAILURE' as const;

export const UPDATE_LITE_TRADE_ORDER_ACTION = 'UPDATE_LITE_TRADE_ORDER_ACTION' as const;
export const UPDATE_LITE_TRADE_ORDER_SUCCESS = 'UPDATE_LITE_TRADE_ORDER_SUCCESS' as const;
export const UPDATE_LITE_TRADE_ORDER_FAILURE = 'UPDATE_LITE_TRADE_ORDER_FAILURE' as const;

export const UPDATE_LITE_TRADE_POSITION_ACTION = 'UPDATE_LITE_TRADE_POSITION_ACTION' as const;
export const UPDATE_LITE_TRADE_POSITION_SUCCESS = 'UPDATE_LITE_TRADE_POSITION_SUCCESS' as const;
export const UPDATE_LITE_TRADE_POSITION_FAILURE = 'UPDATE_LITE_TRADE_POSITION_FAILURE' as const;

export const CLOSE_LITE_TRADE_POSITION_ACTION = 'CLOSE_LITE_TRADE_POSITION_ACTION' as const;
export const CLOSE_LITE_TRADE_POSITION_SUCCESS = 'CLOSE_LITE_TRADE_POSITION_SUCCESS' as const;
export const CLOSE_LITE_TRADE_POSITION_FAILURE = 'CLOSE_LITE_TRADE_POSITION_FAILURE' as const;

export const CANCEL_LITE_TRADE_ORDER_ACTION = 'CANCEL_LITE_TRADE_ORDER_ACTION' as const;
export const CANCEL_LITE_TRADE_ORDER_SUCCESS = 'CANCEL_LITE_TRADE_ORDER_SUCCESS' as const;
export const CANCEL_LITE_TRADE_ORDER_FAILURE = 'CANCEL_LITE_TRADE_ORDER_FAILURE' as const;

export const UPDATE_MARKET_DATA = 'UPDATE_MARKET_DATA' as const; // Note that this action has been hidden in console by middleware
export const UPDATE_MARKET_DATA_CANDLE = 'UPDATE_MARKET_DATA_CANDLE' as const; // Note that this action has been hidden in console by middleware

export const ADD_MARKET_DATA_WATCH_ACTION = 'ADD_MARKET_DATA_WATCH_ACTION' as const;
export const REMOVE_MARKET_DATA_WATCH_ACTION = 'REMOVE_MARKET_DATA_WATCH_ACTION' as const;

export const ADD_MARKET_DATA_CANDLE_WATCH_ACTION = 'ADD_MARKET_DATA_CANDLE_WATCH_ACTION' as const;
export const REMOVE_MARKET_DATA_CANDLE_WATCH_ACTION = 'REMOVE_MARKET_DATA_CANDLE_WATCH_ACTION' as const;

export const GET_LITE_TRADE_ACCOUNT_STAT_PL_ACTION = 'GET_LITE_TRADE_ACCOUNT_STAT_PL_ACTION' as const;
export const GET_LITE_TRADE_ACCOUNT_STAT_PL_SUCCESS = 'GET_LITE_TRADE_ACCOUNT_STAT_PL_SUCCESS' as const;
export const GET_LITE_TRADE_ACCOUNT_STAT_PL_FAILURE = 'GET_LITE_TRADE_ACCOUNT_STAT_PL_FAILURE' as const;

export const GET_LITE_TRADE_MARKET_ACTION = 'GET_LITE_TRADE_MARKET_ACTION' as const;
export const GET_LITE_TRADE_MARKET_SUCCESS = 'GET_LITE_TRADE_MARKET_SUCCESS' as const;
export const GET_LITE_TRADE_MARKET_FAILURE = 'GET_LITE_TRADE_MARKET_FAILURE' as const;

export const GET_LITE_TRADE_MARKET_COLLECTION_ACTION = 'GET_LITE_TRADE_MARKET_COLLECTION_ACTION' as const;
export const GET_LITE_TRADE_MARKET_COLLECTION_SUCCESS = 'GET_LITE_TRADE_MARKET_COLLECTION_SUCCESS' as const;
export const GET_LITE_TRADE_MARKET_COLLECTION_FAILURE = 'GET_LITE_TRADE_MARKET_COLLECTION_FAILURE' as const;

export const UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_ACTION = 'UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_ACTION' as const;
export const UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_SUCCESS = 'UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_SUCCESS' as const;
export const UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_FAILURE = 'UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_FAILURE' as const;

export const UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_ACTION = 'UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_ACTION' as const;
export const UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_SUCCESS = 'UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_SUCCESS' as const;
export const UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_FAILURE = 'UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_FAILURE' as const;

export const INIT_UPS_DOWNS_COLLECTION_ACTION = 'INIT_UPS_DOWNS_COLLECTION_ACTION' as const;
export const INIT_UPS_DOWNS_COLLECTION_SUCCESS = 'INIT_UPS_DOWNS_COLLECTION_SUCCESS' as const;
export const INIT_UPS_DOWNS_COLLECTION_FAILURE = 'INIT_UPS_DOWNS_COLLECTION_FAILURE' as const;

export const UPDATE_LITE_TRADE_CHART_TIMEFRAMES = 'UPDATE_LITE_TRADE_CHART_TIMEFRAMES' as const;
export const UPDATE_LITE_TRADE_CHART_DATA_READY = 'UPDATE_LITE_TRADE_CHART_DATA_READY' as const;

export const CLOSE_ALL_POSITIONS_ACTION = 'CLOSE_ALL_POSITIONS_ACTION';
export const CLOSE_ALL_POSITIONS_SUCCESS = 'CLOSE_ALL_POSITIONS_SUCCESS';
export const CLOSE_ALL_POSITIONS_FAILURE = 'CLOSE_ALL_POSITIONS_FAILURE';

export const SET_DESKTOP_TRADE_TABLE_MODE = 'SET_DESKTOP_TRADE_TABLE_MODE' as const;

export const UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_PORTFOLIO_ACTION =
    'UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_PORTFOLIO_ACTION' as const;
export const UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_PORTFOLIO_SUCCESS =
    'UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_PORTFOLIO_SUCCESS' as const;

export const UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_POSITION_CODE_ACTION =
    'UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_POSITION_CODE_ACTION' as const;

export const INIT_CHART_DRAW_PANEL_OPENED = 'INIT_CHART_DRAW_PANEL_OPENED' as const;
export const SET_CHART_DRAW_PANEL_OPENED = 'SET_CHART_DRAW_PANEL_OPENED' as const;

export const LITE_TRADE_ORDER_STATUSES = {
    CANCELED: 'CANCELED' as const,
    COMPLETED: 'COMPLETED' as const,
    REJECTED: 'REJECTED' as const,
    WORKING: 'WORKING' as const,
}

export const LITE_TRADE_ACCOUNT_EVENT_TYPES = {
    LIQUIDATION: 'LIQUIDATION',
    MARGIN_CALL: 'MARGIN_CALL',
} as const;

export const LITE_TRADE_POSITION_EFFECTS = {
    CLOSE: 'CLOSE' as const,
    OPEN: 'OPEN' as const,
}

// Порядок важен для отоюбражения! Сначала Sell!
export const LITE_TRADE_POSITION_SIDE = {
    SELL: 'SELL',
    BUY: 'BUY',
} as const;

export const MAP_LITE_TRADE_POSITION_OPPOSITE_SIDE = {
    [LITE_TRADE_POSITION_SIDE.SELL]: LITE_TRADE_POSITION_SIDE.BUY,
    [LITE_TRADE_POSITION_SIDE.BUY]: LITE_TRADE_POSITION_SIDE.SELL,
} as const;

export type TLiteTradePositionSide = typeof LITE_TRADE_POSITION_SIDE[keyof typeof LITE_TRADE_POSITION_SIDE];

export const LITE_TRADE_DX_REJECT_CODES = {
    NOT_ENOUGH_SPACE: 'not_enough_space' as const,
    TRADING_HOURS: 'trading_hours' as const,
}

// dx doesnt send some reject id, we have to parse text
export const MAP_LITE_TRADE_DX_REJECT_SUBSTRING_TO_REJECT_CODE = {
    'Your margin is insufficient': LITE_TRADE_DX_REJECT_CODES.NOT_ENOUGH_SPACE,
    'is currently off trading hours': LITE_TRADE_DX_REJECT_CODES.TRADING_HOURS,
}

export const LITE_TRADE_ORDER_LINK_TYPES = {
    CHILD: 'CHILD' as const,
    PARENT: 'PARENT' as const,
}

export const LITE_TRADE_PRICE_SIDE = {
    ASK: 'ask' as const,
    BID: 'bid' as const,
}

export const PRESET_STAT_PL = {
    DAY: 'day' as const,
    WEEK: 'week' as const,
    MONTH: 'month' as const,
    ALL: 'all' as const,
}

export const CHART_TIMEFRAMES = {
    '1': {
        title: 'M1',
        type: 'm',
        inMin: 1,
        startOf: 'minute',
    },
    '5': {
        title: 'M5',
        type: '5m',
        inMin: 5,
        startOf: 'hour',
    },
    '15': {
        title: 'M15',
        type: '15m',
        inMin: 15,
        startOf: 'hour',
    },
    '30': {
        title: 'M30',
        type: '30m',
        inMin: 30,
        startOf: 'hour',
    },
    '60': {
        title: 'H1',
        type: 'h',
        inMin: 60,
        startOf: 'hour',
    },
    '240': {
        title: 'H4',
        type: '4h',
        inMin: 60 * 4,
        startOf: 'day',
    },
    '1D': {
        title: 'D1',
        type: 'd',
        inMin: 24 * 60,
        startOf: 'day',
    },
    '1W': {
        title: 'W1',
        type: 'w',
        inMin: 7 * 24 * 60,
        startOf: 'month',
    },
    // 'mo': {
    //     title: 'MO',
    //     inMin: 30 * 24 * 60,
    //     startOf: 'month',
    // },
} as const;


export type TChartTimeframes = keyof typeof CHART_TIMEFRAMES;

export const TRADING_VIEW_SELECTED_TIMEFRAMES_KEY  = 'tradingViewCharSelectedTimeframes';

export const UPS_DOWNS_ASSETS_COUNT = 10;
